export const PenIcon = () => {
    return (
        <svg
            className="svg"
            width="18"
            height="18"
            viewBox="0 0 18 18"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M3.444 2.737l6.666 1.9.012.004.011.003C12.072 5.146 13.5 6.907 13.5 9c.003.503-.063.912-.211 1.367l-.185.58.43.43 1.865 1.866-2.12 2.121-1.848-1.847-.435-.435-.585.193c-.469.157-.891.228-1.411.225-2.171 0-3.985-1.539-4.407-3.586l-.008-.037-.01-.037-1.832-6.39 4.903 4.903C7.552 8.55 7.5 8.768 7.5 9c0 .828.672 1.5 1.5 1.5.828 0 1.5-.672 1.5-1.5 0-.828-.672-1.5-1.5-1.5-.232 0-.45.052-.647.146l-4.91-4.91zm9.834 14.041l3.536-3.535-2.572-2.572c.167-.527.258-1.089.258-1.671 0-2.56-1.748-4.71-4.115-5.324L1 1l2.613 9.116C4.13 12.618 6.345 14.5 9 14.5c.602 0 1.182-.097 1.724-.276l2.554 2.554z"
                fillRule="nonzero"
                fillOpacity="1"
                fill="#ffffff"
                stroke="none"
            ></path>
        </svg>
    );
}
export const SelectorIcon = () => {
    return (
        <svg
            className="svg"
            width="18"
            height="18"
            viewBox="0 0 18 18"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M9.19875 6.375C7.21125 6.375 5.41125 7.1175 4.02375 8.325L1.32375 5.625V12.375H8.07375L5.35875 9.66C6.40125 8.79 7.72875 8.25 9.19875 8.25C11.8538 8.25 14.1113 9.9825 14.8988 12.375L16.6763 11.79C15.6338 8.6475 12.6863 6.375 9.19875 6.375Z"
                fillRule="nonzero"
                fillOpacity="1"
                fill="#ffffff"
                stroke="none"
            ></path>
        </svg>
    );
};
export const PencilIcon = () => {
    return (
        <svg
            className="svg"
            width="18"
            height="18"
            viewBox="0 0 18 18"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M7.313 16.431l10.82-10.82c.782-.782.782-2.048 0-2.829L16.72 1.368c-.781-.781-2.048-.781-2.829 0l-10.82 10.82-1.061 5.304 5.303-1.06zM12.235 4.44L3.992 12.68l-.707 3.536 3.535-.707 8.243-8.243-2.829-2.828zm.707-.707L15.77 6.56l1.657-1.657c.39-.39.39-1.023 0-1.414l-1.414-1.414c-.39-.39-1.024-.39-1.415 0l-1.657 1.657z"
                fillRule="evenodd"
                fillOpacity="1"
                fill="#ffffff"
                stroke="none"
            ></path>
        </svg>
    );
}

export const TextIcon = () => {
    return (
        <svg
            className="svg"
            width="18"
            height="18"
            viewBox="0 0 18 18"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M2 5h1V2h5v14H5v1h7v-1H9V2h5v3h1V1H2v4z"
                fillRule="evenodd"
                fillOpacity="1"
                fill="#ffffff"
                stroke="none"
            ></path>
        </svg>
    );
}
export const LineIcon = () => {
    return (
        <svg
            className="svg"
            width="18"
            height="18"
            viewBox="0 0 18 18"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M1.354 17.353l16-16-.708-.707-16 16 .708.707z"
                fillRule="evenodd"
                fillOpacity="1"
                fill="#ffffff"
                stroke="none"
            ></path>
        </svg>
    );
}
export const CircleIcon = () => {
    return (
        <svg
            className="svg"
            width="18"
            height="18"
            viewBox="0 0 18 18"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M9 1C4.582 1 1 4.582 1 9c0 4.418 3.582 8 8 8 4.418 0 8-3.582 8-8 0-4.418-3.582-8-8-8zm7 8c0 3.866-3.134 7-7 7-3.866 0-7-3.134-7-7 0-3.866 3.134-7 7-7 3.866 0 7 3.134 7 7z"
                fillRule="evenodd"
                fillOpacity="1"
                fill="#ffffff"
                stroke="none"
            ></path>
        </svg>
    );
}
export const RectangleIcon = () => {
    return (
        <svg
            className="svg"
            width="18"
            height="18"
            viewBox="0 0 18 18"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M1 1h16v16H1V1zm1 1h14v14H2V2z"
                fillRule="evenodd"
                fillOpacity="1"
                fill="#ffffff"
                stroke="none"
            ></path>
        </svg>
    );
}
export const ArrowIcon = () => {
    return (
        <svg
            className="svg"
            width="18"
            height="18"
            viewBox="0 0 18 18"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M11 1h6v6h-1V2.707L1.354 17.354l-.708-.708L15.293 2H11V1z"
                fillRule="evenodd"
                fillOpacity="1"
                fill="#ffffff"
                stroke="none"
            ></path>
        </svg>
    );
}
export const ImageIcon = () => {
    return (
        <svg
            className="svg"
            width="18"
            height="18"
            viewBox="0 0 18 18"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M14.002 2h-12a1 1 0 0 0-1 1v9l2.646-2.354a.5.5 0 0 1 .63-.062l2.66 1.773 3.71-3.71a.5.5 0 0 1 .577-.094L15.002 9.5V3a1 1 0 0 0-1-1zm-12-1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2h-12zm4 4.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"
                fillRule="evenodd"
                fillOpacity="1"
                fill="#ffffff"
                stroke="none"
            ></path>
        </svg>
    );
}
export const EraserIcon = () => {
    return (
        <svg className="svg"
            width="18"
            height="18"
            viewBox="0 0 18 18"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M17.4933 15.7592H16.1766C15.8968 15.7592 15.6699 15.5323 15.6699 15.2525C15.6699 14.9727 15.8968 14.7458 16.1766 14.7458H17.4933C17.7731 14.7458 18 14.9727 18 15.2525C18 15.5323 17.7731 15.7592 17.4933 15.7592Z" fillRule="evenodd"
                fillOpacity="1"
                fill="#ffffff"
                stroke="none" />
            <path d="M15.7351 7.94741C16.1267 7.55581 16.3424 7.03511 16.3424 6.48122C16.3424 5.9274 16.1267 5.40674 15.7351 5.0151L11.5682 0.848134C11.1766 0.456528 10.6559 0.240845 10.1021 0.240845C9.54816 0.240845 9.02754 0.456528 8.63586 0.848134L4.62109 4.86287C4.52609 4.95794 4.47269 5.08678 4.47269 5.22115C4.47269 5.35552 4.52609 5.48436 4.62109 5.57943L10.6455 11.6038L7.50351 14.7458H4.97525L1.3229 11.0935C1.12265 10.8933 1.01237 10.6271 1.01237 10.3439C1.01237 10.0607 1.12265 9.79449 1.3229 9.59431L3.15964 7.75757C3.3575 7.55971 3.3575 7.23891 3.15964 7.04098C2.96175 6.84319 2.64102 6.84319 2.44305 7.04098L0.606313 8.87772C-0.202105 9.68613 -0.202105 11.0015 0.606313 11.81L4.40709 15.6108C4.41029 15.614 4.41377 15.6167 4.417 15.6198C4.42572 15.628 4.43437 15.6363 4.44365 15.6439C4.44766 15.6472 4.45195 15.65 4.45606 15.6532C4.4651 15.6602 4.4741 15.6672 4.48359 15.6736C4.4869 15.6757 4.49038 15.6776 4.49372 15.6797C4.50437 15.6865 4.51509 15.6931 4.52624 15.6991C4.52856 15.7004 4.53105 15.7013 4.53337 15.7026C4.54568 15.709 4.55819 15.715 4.57113 15.7204C4.57271 15.7211 4.57433 15.7215 4.57584 15.7221C4.58952 15.7276 4.60344 15.7328 4.61768 15.7371C4.61936 15.7376 4.62112 15.7379 4.62281 15.7384C4.63684 15.7425 4.65107 15.7463 4.66563 15.7492C4.66964 15.75 4.67375 15.7503 4.67779 15.751C4.68999 15.7532 4.70226 15.7553 4.71478 15.7566C4.73151 15.7583 4.74839 15.7591 4.76533 15.7591H7.71347H13.7443C14.0241 15.7591 14.251 15.5322 14.251 15.2524C14.251 14.9727 14.0241 14.7458 13.7443 14.7458H8.93669L11.7204 11.9621L15.7351 7.94741ZM9.35245 1.56472C9.55263 1.36447 9.81887 1.25419 10.1021 1.25419C10.3852 1.25419 10.6514 1.36447 10.8516 1.56472L15.0185 5.73165C15.2188 5.93183 15.3291 6.19807 15.3291 6.48122C15.3291 6.7644 15.2188 7.03064 15.0185 7.23082L11.3621 10.8874L5.69592 5.22118L9.35245 1.56472Z" fillRule="evenodd"
                fillOpacity="1"
                fill="#ffffff"
                stroke="none" />
            <path d="M11.6618 14.3473C11.4954 14.3473 11.3325 14.2655 11.2356 14.1152C11.0839 13.88 11.1516 13.5665 11.3867 13.4148L12.8107 12.4962C13.0459 12.3444 13.3593 12.4121 13.5111 12.6473C13.6628 12.8824 13.5951 13.196 13.36 13.3477L11.936 14.2663C11.8511 14.3211 11.7559 14.3473 11.6618 14.3473Z" fillRule="evenodd"
                fillOpacity="1"
                fill="#ffffff"
                stroke="none" />
        </svg>
    )
}
export const DownloadIcon = () => {
    return (
        <svg className="svg"
            width="18"
            height="18"
            viewBox="0 0 18 18"
            xmlns="http://www.w3.org/2000/svg">
            <path fillOpacity="1"
                fill="#ffffff" xmlns="http://www.w3.org/2000/svg" d="M14.25 9V14.25H3.75V9H2.25V14.25C2.25 15.075 2.925 15.75 3.75 15.75H14.25C15.075 15.75 15.75 15.075 15.75 14.25V9H14.25ZM9.75 9.5025L11.6925 7.5675L12.75 8.625L9 12.375L5.25 8.625L6.3075 7.5675L8.25 9.5025V2.25H9.75V9.5025Z" />
        </svg >
    )
}